import { Image } from "react-bootstrap";
import brandConfig from "../../../../config/chooseBrand";

export default function Logo({ ...props }) {
    const logo = brandConfig().config.logo;
    const brand = brandConfig().name;
    return (
        <>
            <Image src={logo} alt={`${brand} Logo`} width={39} height={39} />
        </>
    );

}
